import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Wrapper = styled.div`
	background-color: ${colors.grey1};
	height: 100%;
	padding: 1%;
	.ag-theme-balham {
		width: 100%;
		height: 78vh;

		@media (max-width: 1440px) {
			height: 79vh;
		}

		@media (max-width: 1366px) {
			height: 74vh;
		}

		.ag-header-cell {
			text-align: center;
		}
		.ag-header-row {
			.ag-header-cell {
				.ag-cell-label-container {
					justify-content: center;

					.ag-header-cell-label {
						flex: unset;
					}
				}
			}
		}
		.ag-row {
			.ag-cell {
				text-align: center;
			}
		}
	}
`;
